module.exports = __webpack_public_path__ + "ng.dda0e5c8.svg";